(() => {
 'use strict';
 // Show store benefits on the homepage and product pages only.
 if(location.pathname!=='/'&&!/^\/products(\/|$)/.test(location.pathname))return;
 if(document.querySelector('.cabane-shop-services'))return;
 const footer=document.querySelector('footer.lcg-reference-footer,footer.footer,body>footer');
 if(!footer)return;
 const icons={
  delivery:'<path d="M8 35V15h32v29H8v-9Zm32-12h10l9 12v9H40"/><path d="M45 27v9h12M4 24h12M3 31h10M13 10h17"/><circle cx="19" cy="46" r="6"/><circle cx="49" cy="46" r="6"/><path d="m22 23 5-5 5 5v10H22Z"/>',
  shop:'<path d="M11 27v28h42V27M7 18l5-9h40l5 9v8H7Z"/><path d="M7 26c0 8 10 8 10 0 0 8 10 8 10 0 0 8 10 8 10 0 0 8 10 8 10 0 0 8 10 8 10 0M17 39h10v16M35 38h11v9M20 9l-3 17M30 9l-3 17M38 9l-1 17M46 9l1 17"/>',
  workshop:'<path d="M40 8a14 14 0 0 0-15 19L8 44a7 7 0 0 0 10 10l17-17A14 14 0 0 0 53 19l-9 9-9-3-3-9Z"/><circle cx="14" cy="49" r="2"/><path d="m48 43 7 7M51 40l7 7M15 15l-5-5M9 23H4M24 9V4"/>',
  returns:'<path d="M15 18a23 23 0 1 1-5 27M15 7v13H3"/><path d="m22 28 10-5 11 5v15l-11 6-10-6ZM22 28l10 6 11-6M32 34v15M27 25l11 6"/>',
  contact:'<path d="M7 10h40v29H26l-12 9v-9H7Z"/><path d="M47 21h10v30H47l-9 7v-7H28v-8M17 20h20M17 28h14"/>'
 };
 const items=[
  ['delivery','/policies/shipping-policy','Livraison offerte','dès 90 € d’achat'],
  ['shop','/pages/contact','Retrait gratuit','au shop de Lille'],
  ['workshop','/pages/atelier-reparation-lille','Atelier au shop','découpe de guidon offerte'],
  ['returns','/policies/refund-policy','Retours & échanges','consulte nos conditions'],
  ['contact','/pages/contact','On est là pour toi','07 69 42 00 71']
 ];
 const section=document.createElement('section');section.className='cabane-shop-services';section.setAttribute('aria-label','Les services de La Cabane de la Glisse');
 section.innerHTML='<div class="cabane-shop-services__grid">'+items.map(([icon,href,title,detail])=>`<a class="cabane-shop-services__item" href="${href}"><svg aria-hidden="true" viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">${icons[icon]}</svg><span><strong>${title}</strong><span>${detail}</span></span></a>`).join('')+'</div>';
 const product=document.querySelector('.product-layout');
 const bestsellers=document.querySelector('section[id*="__bestsellers_refonte"],div.shopify-section[id*="__bestsellers_refonte"]');
 if(product){
  section.classList.add('cabane-shop-services--product');
  product.after(section);
 }else if(location.pathname==='/'&&bestsellers){
  bestsellers.after(section);
 }else{
  const wrapper=footer.closest('.shopify-section-group-footer-group');
  (wrapper||footer).before(section);
 }
})();
